import React, { useState } from 'react';
import { Input } from './input';
import styles from './input.module.scss';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { InputProps } from './types';

export const PasswordInput: React.FC<InputProps> = props => {
    const [show, setShow] = useState(false);

    return (
        <div className={styles.passwordWrapper}>
            <Input {...props} type={show ? 'text' : 'password'} />
            <span
                className={styles.toggleIcon}
                onClick={() => setShow(prev => !prev)}
            >
                {show ? <EyeOutlined /> : <EyeInvisibleOutlined />}
            </span>
        </div>
    );
};
